import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AssuredWorkloadIcon(props: IconProps) {
    return <Icon {...props} iconKey={"assured_workload"}/>
}
